import { jsx as i } from "react/jsx-runtime";
import { c as u } from "../../../index-Cu0xwYjD.js";
import { propagateTestid as f } from "../../../utils/helpers.js";
import { IressValidationMessage as p } from "../ValidationMessage.js";
import "react";
import { useIdIfNeeded as c } from "../../../utils/hooks/useIdIfNeeded.js";
import { IressValidationLink as y } from "../ValidationLink/ValidationLink.js";
const v = "ids-validation-summary-v501", I = {
  validationSummary: v
}, S = ({
  children: a,
  "data-testid": r,
  linkToTarget: e,
  prefix: o,
  status: d,
  visiblePrefix: s
}) => e ? /* @__PURE__ */ i(
  y,
  {
    linkToTarget: e,
    status: d,
    prefix: o,
    visiblePrefix: s,
    "data-testid": r,
    children: a
  }
) : /* @__PURE__ */ i(
  p,
  {
    status: d,
    prefix: o,
    visiblePrefix: s,
    "data-testid": r,
    children: a
  }
), b = ({
  messages: a = [],
  linkToTarget: r,
  prefix: e,
  visiblePrefix: o,
  status: d = "danger",
  className: s,
  "data-testid": n,
  ...m
}) => {
  const l = c({ id: m.id });
  return a.length ? /* @__PURE__ */ i(
    "ul",
    {
      ...m,
      className: u(s, I.validationSummary),
      "data-testid": n,
      children: a.map((t) => /* @__PURE__ */ i("li", { children: /* @__PURE__ */ i(
        S,
        {
          linkToTarget: t.linkToTarget ?? r,
          status: t.status ?? d,
          prefix: t.prefix ?? e,
          visiblePrefix: t.visiblePrefix ?? o,
          "data-testid": t.dataTestId ?? f(n, "error"),
          children: t.message
        }
      ) }, `${l}-${t.linkToTarget}-${t.message}`))
    }
  ) : null;
};
export {
  b as IressValidationSummary
};
